import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState("All");

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data));
  }, []);

  const categories = useMemo(() => {
    const set = new Set(items.map((i) => i.category));
    return ["All", ...Array.from(set)];
  }, [items]);

  const filtered = active === "All" ? items : items.filter((i) => i.category === active);

  return (
    <>
      <SEO title="Gallery" description="Inside Forage — production halls, QC laboratory, packaging, team and field outreach." path="/gallery" />

      <section className="bg-[#0B2545] text-white py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden">
        <div className="absolute inset-0 grid-pattern opacity-20" />
        <div className="container-fr relative">
          <span className="overline text-[#2A9D8F]">Gallery</span>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-black mt-3 leading-tight max-w-3xl">
            A look inside Forage.
          </h1>
          <p className="text-lg text-slate-300 mt-6 max-w-2xl">
            Production halls, QC laboratory, packaging, team and field outreach.
          </p>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-fr">
          <div className="flex flex-wrap gap-2 mb-10">
            {categories.map((c) => (
              <button
                key={c}
                data-testid={`gallery-filter-${c}`}
                onClick={() => setActive(c)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  active === c
                    ? "bg-[#0B2545] text-white"
                    : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {filtered.map((g, i) => (
              <div
                key={g.id}
                className="group relative overflow-hidden rounded-xl bg-slate-100 fade-up"
                style={{ animationDelay: `${i * 50}ms` }}
              >
                <img src={g.image_url} alt={g.title} loading="lazy" className="w-full h-72 object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-90" />
                <div className="absolute bottom-4 left-4 right-4 text-white">
                  <div className="text-[10px] uppercase tracking-wider text-[#2A9D8F] font-semibold">{g.category}</div>
                  <div className="font-display text-lg font-bold mt-1">{g.title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
